export default "__VITE_ASSET__Do_7icpH__"